module.exports = __webpack_public_path__ + "img/public/AdminIcons/messageicon.svg?e525d7e7";